<script setup>
import BrandsList from '@/components/BrandsList.vue';
import BrandsSlider from '@/components/BrandsSlider.vue';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        class="brands"
        :class="[
          data?.background_color === 'black' ? 'white' : '',
          `brands--${data?.template}`,
        ]"
      >
        <div class="brands__top">
          <h2
            v-if="data?.title"
            class="mb-0 brands__title h2"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="data?.title"
          ></h2>
          <div
            v-if="data?.description"
            :class="[
              'brands__description',
              data?.template === 'with_strategic'
                ? 'body-1-regular'
                : 'body-2-regular',
            ]"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="data?.description"
          ></div>
        </div>
        <BrandsSlider
          v-if="data.template === 'slider'"
          :items="data.items"
          :background-color="data.background_color"
        />
        <BrandsList
          v-else
          :template="data?.template"
          :items="data.items"
          :background-color="data.background_color"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.brands {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 32px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(md) {
      margin: 0 auto;
      width: 66.6%;
    }
  }
  &__description {
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
  }
}
</style>
